<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'

export default {
    mixins: [messages],
    data() {
        return {
            formState: {},
            loading: false,
            username: null,
            password: null,
        }
    },
    props: {
        forgotPassword: {
            type: Boolean,
            default: true,
        },
        register: {
            type: Boolean,
            default: true,
        },
        submitText: {
            type: String,
            default: 'Submit'
        }
    },
    methods: {
        async onSubmit() {
            try {
                if (this.formState.$invalid) {
                    return false
                }

                let result = await this.$store.dispatch('login', { username: this.username, password: this.password })
                this.$emit('success', result.userResource)
            } catch (e) {
                this.addError(this.parseAPIErrorsOrRethrow(e))
            } finally {
                this.loading = false
            }
        },
        onClickRegister(e) {
            this.$emit('register')
        },
        onClickForgotPassword(e) {
            this.$emit('forgotPassword')
        },
    },
}
</script>

<template>
    <vue-form :state="formState" @submit.prevent="onSubmit">

        <validate auto-label>
            <b-form-group label="Email Address or Username:">
                <b-form-input name="email" v-model="username" required />
                <field-messages name="email" show="$submitted">
                    <div slot="required" class="text-danger">
                        This field is required
                    </div>
                </field-messages>
            </b-form-group>
        </validate>

        <validate auto-label>
            <b-form-group label="Password:">
                <b-form-input name="password" type="password" v-model="password" required />
                <field-messages name="password" show="$submitted">
                    <div slot="required" class="text-danger">
                        This field is required
                    </div>
                </field-messages>
            </b-form-group>
        </validate>

        <messages :to="messages" />

        <slot name="footer">
            <b-button type="submit" variant="primary" size="lg" :disabled="loading">{{ submitText }}</b-button>
            <b-button v-if="register" @click="onClickRegister" variant="link" size="sm" class="float-right">Register</b-button>
            <b-button v-if="forgotPassword" @click="onClickForgotPassword" variant="link" size="sm" class="float-right">Forgot Password?</b-button>
        </slot>
    </vue-form>
</template>
